<template>
  <Context>
    <AppBlock />
    <!--  global-->
    <SpriteSvg />
  </Context>
</template>

<script>
import Context from "@/components/global/Context.vue";
import SpriteSvg from "@/components/global/SpriteSvg.vue";
import AppBlock from "@/components/parts/AppBlock.vue";
export default {
  name: 'App',
  components: {
    AppBlock,
    SpriteSvg,
    Context
  },
  methods: {
    updateVh() {
      let vh = (window.innerHeight * 0.01).toFixed(2);
      const header = document.querySelector('.top-panel__container');
      const headerHeight = header ? header.offsetHeight : 70;

      document.documentElement.style.setProperty('--vh', `${vh}px`);
      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
    },
  },
  mounted() {
    this.updateVh();
    window.addEventListener('resize', this.updateVh);
  },
  destroyed() {
    window.removeEventListener('resize', this.updateVh);
  },
}
</script>
